<template>
<!-- Footer -->
<MDBFooter bg="dark" :text="['center', 'white']" class="position">
    <!-- Grid container -->

    <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2)">
        © 2024 Copyright:
        <a class="text-white" href="https://nelson360.github.io/">Nelson.com</a>
    </div>
    <!-- Copyright -->
</MDBFooter>
<!-- Footer -->
</template>

<script>
export default {
    name: 'FooterComponent',

}
</script>

<style>
.position {
    position: relative;
    margin-top: 0%;
    top: 2%;
    left: 2%;
}
</style>
